<div *ngIf="new === false" class="container mt-2">
  <div class="row">
    <div class="col-12 ">
      <h2 class="col-12 primary-font"><b>FAQ</b></h2>


      <!--Catégorie 1-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie1 = true" (closed)="categorie1 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Inscription et compte personnel</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Inscription</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question1_1 = true" (closed)="question1_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Quel âge minimal est nécessaire ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Voiture sans permis (BSR/Permis AM) : 14 ans<br />

              Voiture avec permis : 18 ans
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question1_2 = true" (closed)="question1_2 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">L’inscription est-elle payante ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">L’inscription est gratuite.</p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question1_3 = true" (closed)="question1_3 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Quels sont les documents à fournir lors de mon inscription?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Pour les services de recharge : Aucun document n'est demandé, il vous suffit d'enregistrer vos coordonnées
              et informations personnelles puis d'enregistrer vos coordonnées bancaires.<br />
              Pour les services d'autopartage de véhicule : Un permis de conduire valable et un justificatif de domicile
              daté de moins de 3 mois vous seront demandés.<br /> Si le justificatif de domicile n'est pas au même nom
              que le
              permis de conduire, une attestation d'hébergement ainsi que la carte d'identité de l'hébergeant sont
              attendues.<br /> Si le permis de conduire est étranger (hors Union Européenne), un titre de séjour valable
              est à
              fournir...
              Pour certaines communautés/formules, d'autres documents peuvent être demandés (Justificatif étudiant,
              carte abonnement Libeo, fiches de paies)...
              Pour les services d'autopartage de vélo : Une carte d'identité recto/verso et un justificatif de domicile
              daté de moins de 3 mois vous seront demandés.<br /> Si le justificatif de domicile n'est pas au même nom
              que la
              carte d'identité, une attestation d'hébergement ainsi que la carte d'identité de l'hébergeant sont
              attendues.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question1_4 = true" (closed)="question1_4 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Quel type de permis de conduire est nécessaire pour m’inscrire
                  ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Voiture sans permis : Permis AM ou BSR<br />
              Voiture avec permis : Permis B<br />

              Le permis de conduire étranger est valable si :<br />
              - Je suis étudiant(e) en France (fournir un titre de séjour
              étudiant)<br />
              -Je suis arrivé(e) en France depuis moins d’1 an (fournir un titre
              de séjour)<br />

              Pour les permis internationaux, votre permis international doit
              être valable en France. Pour les permis internationaux, votre
              permis international doit être valable en France (fournir
              également la preuve que le permis étranger est accepté par la
              France).<br />

              Le certificat d'examen au permis de conduire n'est pas accepté.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_5 = true" (closed)="question1_5 = false">
            <mat-expansion-panel-header class="panelheader4">
              <mat-panel-title>
                <p class="childbloc">
                  Je n’ai pas pu finaliser mon inscription parce que j’ai
                  rencontrée des difficultés, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut envoyer un mail au service usagers, en joignant des
              captures d’écrans des difficultés rencontrées en pièce jointe à
              l’adresse e-mail contact@clem.mobi<br />
              Expliquez également dans votre mail les difficultés que vous avez
              rencontrés avec le plus de détails possible.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_6 = true" (closed)="question1_6 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Puis-je accéder au service dès mon inscription ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Autopartage : un délai de validation de mon dossier d’inscription
              de 48H ouvrées est nécessaire.<br />

              Recharge : Une fois votre carte bancaire enregistrée, le compte
              est activé automatiquement.<br />

              Vous recevrez un e-mail pour vous informer de l’activation de
              votre compte. Pensez à vérifier vos courriers indésirables/ spams.
            </p>
          </mat-expansion-panel>

          <p class="text-center bloc text-light">Compte personnel</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_7 = true" (closed)="question1_7 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc pt-1">
                  J’ai perdu mon identifiant/login ou mon mot de passe, que
                  dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Perte d’identifiant/login  envoyer un e-mail à :
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a><br />
              Perte de mot de passe : cliquer sur le lien suivant :
              <a href="https://www.clem.mobi/connexion/lost-password " target="_blank">Mot de passe oublié ?</a>
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_8 = true" (closed)="question1_8 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Comment modifier mes informations personnelles ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Vous avez la possibilité de changer de mot de passe et de numéro
              de téléphone directement sur votre espace client dans la rubrique
              :
              <a href="https://www.clem.mobi/user" target="_blank">Mon Profil</a>
              <br />
              Pour modifier votre adresse et courriel, contactez le service client : contact@clem.mobi
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_9 = true" (closed)="question1_9 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Comment ajouter un second conducteur sur mon compte
                  personnel ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Si votre formule tarifaire le permet, procédez à l’inscription de
              la personne souhaitée. Envoyez par la suite un e-mail à <a href="mailto:contact@clem.mobi"
                target="_blank">contact@clem.mobi</a>
              en indiquant que vous souhaitez le rattachement d’un second
              conducteur à votre compte.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_10 = true" (closed)="question1_10 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Pourquoi mon compte est suspendu ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Pour connaître le motif de votre suspension merci de contacter le
              service client, par mail à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question1_11 = true" (closed)="question1_11 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title class="childbloc">
                <p>Quand et comment puis-je résilier mon abonnement ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Si vous n’avez plus d’engagement, envoyez une demande par mail à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 2  Réservation-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie2 = true" (closed)="categorie2 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Réservation</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question2_1 = true" (closed)="question2_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Comment louer un véhicule ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Une fois la création de votre compte validé, connectez-vous à
              votre espace client pour réserver un véhicule.<br />Vous pouvez
              par la suite vous rendre à la station au début de votre
              réservation afin d’accéder au véhicule.<br />Une heure avant votre
              réservation, un code pour accéder au véhicule vous sera transmis
              par sms / email. Pensez à vérifier vos courriers indésirables /
              spams.
            </p>
          </mat-expansion-panel>


              <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question2_1_1 = true" (closed)="question2_1_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Validation de la pré-autorisation et réception du code de réservation ( Ma réservation est annulée? )</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
               12h avant votre départ, vous recevez un email avec un lien de validation de la pré-autorisation. Vous devez valider cette pré-autorisation sur votre terminal bancaire.
            </p>
                 <p class="textbloc">
               En cas d'échec, vous pouvez reproduire cette opération autant de fois que vous le souhaitez jusqu'à 1h avant la réservation.
            </p>
                 <p class="textbloc">
               1h avant la réservation, si votre pré-autorisation a été validée, alors vous recevez votre code de réservation par sms, par mail et sur clem.mobi (web ou app) dans 'mes réservations'
            </p>
                  <p class="textbloc">
               (i) si vous réservez dans l'heure précédent votre réservation, alors vous recevez immédiatement ce mail et avez 15minutes pour effectuer la validation de pré-autorisation. Une fois votre pré-autorisation validée, vous recevez immédiatement votre code de réservation par sms, par mail et sur clem.mobi (web ou app).
            </p>
            <p class="textbloc">
              Besoin d'assistance avec la pré-autorisation :
              <a href="https://www.clem-e.com/a5" target="_blank">
                www.clem-e.com/a5
              </a>
            </p>
           
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center text-light bloc">Avant ma réservation</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question2_2 = true" (closed)="question2_2 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Puis-je louer plusieurs véhicules en même temps ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Sur un même créneau horaire, une seule location est possible à la
              fois. Vous pouvez néanmoins réaliser plusieurs réservations à
              l’avenir sur des créneaux qui ne se chevauchent pas.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question2_3 = true" (closed)="question2_3 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">A quel modèle de véhicule ai-je accès ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Nous avons différents modèles de véhicules selon les
              communautés.<br />
              Vérifiez sur la carte les types de véhicules disponibles autour de
              vous.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question2_4 = true" (closed)="question2_4 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Quelle est l’autonomie d’un véhicule ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              L’autonomie du véhicule ne dépend pas du temps, mais de la
              distance parcourue, elle varie selon le type de véhicule, pouvant
              aller de 100 à 300 km. L’autonomie estimée est indiquée au moment
              de la réservation.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question2_5 = true" (closed)="question2_5 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Qu’est-ce qui est inclus dans ma réservation ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              La location du véhicule durant le temps de ma réservation,
              l’assurance, l’énergie et la place de parking de la station de
              mobilité.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Imprévus</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question2_6 = true" (closed)="question2_6 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Comment savoir quel véhicule j’ai réservé ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Nous vous invitons à consulter l’e-mail de confirmation de
              réservation ou directement sur la plateforme dans l’onglet
              <a href="https://clem.mobi/auth/reservations" target="_blank">Mes réservations</a>
              Pensez à vérifier vos courriers indésirables / spams.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question2_7 = true" (closed)="question2_7 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Je souhaite modifier ou annuler ma réservation, que dois-je
                  faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Modification : Vous avez la possibilité de prolonger votre
              réservation.<br />Pour cela, rendez-vous sur votre espace client
              dans la rubrique :
              <a href="https://clem.mobi/auth/reservations" target="_blank">Mes réservations.</a>
              Pour toute autre modification, vous devez annuler votre
              réservation, puis en réaliser une nouvelle.<br />
              Annulation : L’annulation est possible jusqu’à 1 heure avant le
              début de la réservation.<br />Rendez-vous sur votre espace client,
              dans la rubrique :
              <a href="https://clem.mobi/auth/reservations" target="_blank">Mes réservations</a>
              <br />
              Pour annuler sa réservation pour cause d'urgence (moins d'une heure avant le début de la réservation),
              contactez le service client au 0186868585 (disponible du lundi au vendredi de 10h à 12h puis de 14h à 17h)
              ou l'assistance technique au 0186860149.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Service de recharge</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question2_8 = true" (closed)="question2_8 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Dois-je réserver pour recharger mon véhicule ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Si vous êtes utilisateur Clem’, vous devez réserver pour utiliser le service.
              Certaines bornes sont interopérables via GIREVE, dans ce cas-là,
              vérifiez si votre opérateur a signé un accord d’itinérance avec
              Clem’ et suivez les indications de votre opérateur.
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 3  Accès au véhicule-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie3 = true" (closed)="categorie3 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Accès au véhicule</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">De l'extérieur</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question3_1 = true" (closed)="question3_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Comment ouvrir le véhicule que j’ai loué ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              En fonction de votre territoire deux technologies vous permettent
              d’accéder au véhicule :<br />
            </p>
            <p class="textbloc">- Via le guichet :</p>
            <p class="textbloc">
              Grâce à votre code de réservation reçu une heure avant le début de
              votre réservation par SMS/mail vous déverrouillez le guichet pour
              accéder aux clés.<br />
            </p>
            <p class="textbloc">- Via l’application mobile :</p>
            <p class="textbloc">
              Depuis votre réservation sur l’application mobile cliquez sur
              «Commencer» pour déverrouiller le véhicule.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question3_2 = true" (closed)="question3_2 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai réservé une Renault Zoé, comment brancher ou débrancher
                  le câble côté voiture ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Une fois en possession des clés du véhicule, appuyez sur le bouton
              représentant une prise électrique.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question3_3 = true" (closed)="question3_3 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Que signifie la couleur de la place de parking devant la borne
                  ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Bleu = recharge, réservée aux propriétaires de véhicules
              électriques qui souhaitent se recharger sur les bornes gérées par
              Clem’.<br />
              Vert = autopartage, réservée au véhicule autopartage associé à
              cette station.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">De l'intérieur</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question3_4 = true" (closed)="question3_4 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Comment démarrer le véhicule que j’ai loué ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Suivez le guide d’utilisation présent dans le véhicule ou
              contactez l’assistance technique (numéro présent dans le SMS/mail
              de confirmation de réservation).
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question3_5 = true" (closed)="question3_5 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Dois-je fermer la borne avant et après chaque utilisation ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              La porte de la borne doit être fermée. Veillez à débrancher le
              câble de recharge côté borne (sauf si le câble est fixé à la
              borne) et de le ranger dans le véhicule avant de partir de
              l’emplacement.<br />

              En cas de problème de fermeture, il faut contacter le numéro de
              l’assistance technique présent dans le SMS/mail de confirmation de
              réservation.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Contrôle du véhicule</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question3_6 = true" (closed)="question3_6 = false">
            <mat-expansion-panel-header class="panelheader4">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai constaté des dommages avant l’utilisation du véhicule que
                  j’ai loué, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
       
              <p class="textbloc">
                  . Avant de partir, vous devez signaler toute anomalie sur le véhicule sur votre espace clem.mobi rubrique « État du Véhicule » ou par email à  <a href="mailto:edv@clem.mobi">edv@clem.mobi</a> <a href="https://www.clem-e.com/a5" target="_blank" rel="noopener">
                    Comment faire</a>.<br><br>

                  . Au départ, ne prenez le véhicule seulement s’il a assez d’autonomie pour votre besoin ou que vous savez où et comment le recharger par vos propres moyens.<br><br>

                  . Le cas échéant, appelez l’assistance technique pour annuler votre réservation.<br><br>

                  . Au retour, votre réservation se termine lorsque le véhicule est fermé et en charge.<br><br>

                  . Il est également nécessaire de faire un état du véhicule retour en suivant la même démarche qu’au départ.<br><br>

                  . Si aucun état du véhicule n’est effectué, vous prenez la responsabilité de tous les dégâts pouvant subvenir après votre réservation et jusqu’à la réservation suivante.
                </p>

          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Départ</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question3_7 = true" (closed)="question3_7 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Je souhaite transporter des animaux domestiques dans le
                  véhicule que j’ai loué, est-ce possible ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il est formellement interdit de transporter des animaux à bord du
              véhicule, sous peine d’une facturation d’une pénalité.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question3_8 = true" (closed)="question3_8 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Je souhaite transporter un bébé à bord du véhicule que j’ai
                  loué, est-ce possible ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Oui, cela est possible. Il faudra cependant vous munir de votre
              propre siège auto.
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 4  Trajet-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie4 = true" (closed)="categorie4 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Trajet</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Utilisation</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question4_1 = true" (closed)="question4_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">Quelle distance puis-je effectuer ?</p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              L’autonomie du véhicule varie selon le type de véhicule, pouvant
              aller de 100 à 300 km. L’autonomie théorique est indiquée au
              moment de la réservation, l’autonomie totale dépendra également de
              la conduite pratiquée.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Lors de l'utilisation</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question4_2 = true" (closed)="question4_2 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Où puis-je consulter l’autonomie restante du véhicule que j’ai
                  loué ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              L’autonomie restante est indiquée sur le tableau de bord du
              véhicule.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question4_3 = true" (closed)="question4_3 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Je souhaite que l’un de mes proches conduise le véhicule que
                  j’ai loué, ai-je le droit ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Cela est formellement interdit, votre réservation est personnelle.
              La personne qui conduit doit être celle au nom duquel la
              réservation a été faite.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question4_4 = true" (closed)="question4_4 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Je souhaite fumer ou vapoter à l’intérieur du véhicule, est-ce
                  possible ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Cela est formellement interdit, sous peine d’une facturation d’une
              somme forfaitaire et sous peine de suspension du service.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question4_5 = true" (closed)="question4_5 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Où est-ce que je peux garer le véhicule que j’ai loué au cours
                  de mon utilisation ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Vous pouvez garer le véhicule dans les emplacements autorisés par
              le code de la route.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Imprévus</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question4_6 = true" (closed)="question4_6 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Je n’ai plus beaucoup d’autonomie disponible dans le véhicule
                  que j’ai loué, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut que vous trouviez une borne de recharge proche de vous et
              vérifiez que celle-ci soit compatible pour y recharger le
              véhicule loué.<br />Nous vous conseillons d’utiliser le site
              <a href="https://www.chargemap.com" target="_blank">www.chargemap.com</a>
              pour trouver une borne de charge autour de vous si besoin.
              N’oubliez pas de prolonger votre réservation en cas de retard.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question4_7 = true" (closed)="question4_7 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Je suis tombé(e) en panne mécanique, de batterie ou une
                  crevaison, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut contacter le numéro de l’assistance technique présent dans
              le SMS/mail de confirmation de réservation.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question4_8 = true" (closed)="question4_8 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Je n’ai plus de batterie sur mon téléphone, que dois-je faire
                  ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Vous avez la responsabilité d’avoir un niveau de batterie sur
              votre téléphone suffisant, de telle sorte à pouvoir joindre notre
              assistance technique en cas de problème.
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 5  Restitution du véhicule-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie5 = true" (closed)="categorie5 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Restitution du véhicule</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question5_1 = true" (closed)="question5_1 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Puis-je restituer le véhicule que j’ai loué à une autre
                  station ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Non, chaque véhicule doit être restitué à son emplacement de
              départ.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question5_2 = true" (closed)="question5_2 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Dois-je restituer le véhicule que j’ai loué chargé ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Ce n’est pas une obligation. Cependant, vous devez OBLIGATOIREMENT rebrancher le
              véhicule lors de sa restitution, afin qu’il puisse recharger pour
              l’usager suivant.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question5_3 = true" (closed)="question5_3 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Dois-je nettoyer le véhicule que j’ai loué, avant de le
                  restituer ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Le véhicule doit être rendu propre. Vous avez donc la
              responsabilité de le nettoyer si vous l’avez sali lors de votre
              utilisation.<br />
              En cas de non-respect de cette règle, il vous sera facturé les
              pénalités prévues dans nos
              <a href="https://clem.mobi/cgu">Conditions Générales d’Utilisation</a>
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question5_4 = true" (closed)="question5_4 = false">
            <mat-expansion-panel-header class="panelheader4">
              <mat-panel-title>
                <p class="childbloc">
                  L’emplacement de stationnement n’est plus disponible pour que
                  je puisse me garer, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Vous devez appeler la police municipale afin qu’ils enlèvent le
              véhicule. En cas de problème, il faut contacter le numéro de
              l’assistance technique présent dans le SMS/mail de confirmation de
              réservation.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question5_5 = true" (closed)="question5_5 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Je n’arrive pas à finaliser ma restitution, que dois-je faire
                  ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut contacter le numéro de l’assistance technique présent dans
              le SMS/mail de confirmation de réservation.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Imprévus</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question5_6 = true" (closed)="question5_6 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai restitué le véhicule avec du retard, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Pour éviter la facturation de pénalité due à un retard, vous devez
              prolonger votre réservation, avant que l’heure de retour prévue
              soit passée.<br />
              Pour prolonger votre réservation, rendez-vous sur votre espace
              client, dans la rubrique :
              <a href="https://clem.mobi/auth/reservations" target="_blank">Mes réservations</a>
              <br />
              Si la prolongation depuis l'application ou le site internet s'avère impossible, contacter immédiatement le
              service client au 0186868585 (disponible du lundi au vendredi de 10h à 12h puis de 14h à 17h) ou
              l'assistance technique au 0186860149.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question5_7 = true" (closed)="question5_7 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai oublié un objet personnel à l’intérieur du véhicule,
                  comment le récupérer ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Nous vous invitons à consulter le planning de réservation du
              véhicule dans lequel vous avez oublié vos objets personnels. Si le
              véhicule n’est pas réservé, nous vous invitons alors à contacter
              le numéro de l’assistance technique présent dans le SMS/mail de
              confirmation de réservation, pour que vous puissiez récupérer vos
              effets personnels. Dans le cas contraire (véhicule réservé), nous
              vous invitons à attendre le retour du véhicule à son emplacement
              pour contacter l’assistance technique.
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 6  Dommages-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie6 = true" (closed)="categorie6 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Dommages</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Lors de mon utilisation</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question6_1 = true" (closed)="question6_1 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai fait une infraction au code de la route, que dois-je
                  faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">Vous recevrez la contravention chez vous.</p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question6_2 = true" (closed)="question6_2 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai eu un accident, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut contacter le numéro de l’assistance technique présent dans
              le SMS/mail de confirmation de réservation, afin d’expliquer les
              circonstances de l’accident et pour que notre équipe vous apporte
              tous les éléments nécessaires afin d’ouvrir un dossier de sinistre
              auprès de notre assurance. Remplissez également un constat
              (présent dans la boîte à gants du véhicule) et l'envoyer à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question6_3 = true" (closed)="question6_3 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Le véhicule que j’ai loué a été remorqué/volé pendant mon
                  utilisation, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut contacter le numéro de l’assistance technique présent dans
              le SMS/mail de confirmation de réservation, afin d’expliquer les
              circonstances de ce que vous avez constaté.
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Lors de ma réservation</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question6_4 = true" (closed)="question6_4 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai abimé le véhicule que j’ai loué au cours de ma
                  réservation, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Veuillez prendre des photos des dégâts occasionnés sur le véhicule
              et nous les transmettre par mail à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>, en
              détaillant les faits/circonstances. Des pénalités sont appliquées
              pour tout dégât non déclaré.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question6_5 = true" (closed)="question6_5 = false">
            <mat-expansion-panel-header class="panelheader4">
              <mat-panel-title>
                <p class="childbloc">
                  Au cours de ma réservation, j’ai retrouvé le véhicule que j’ai
                  loué endommagé, que dois-je faire ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              En cas de dommages lors de l’utilisation vous êtes responsable,
              sauf si le tiers responsable signe un constat à l’amiable. Vous
              devez prendre des photos des dégâts occasionnés sur le véhicule et
              nous les transmettre par mail à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>, en
              détaillant les faits/circonstances.
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 7  Mes paiements-->
      <mat-accordion>
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie7 = true" (closed)="categorie7 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Facturation</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Mes paiements</p>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question7_1 = true" (closed)="question7_1 = false">
            <mat-expansion-panel-header class="panelheader1">
              <mat-panel-title>
                <p class="childbloc">
                  Quels sont les moyens de paiement disponibles ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Le paiement se fait par carte bancaire que vous devez
              préalablement enregistrer sur votre espace client. Pour cela,
              rendez-vous dans la rubrique
              <a href="https://clem.mobi/auth/mes-paiements">Mes paiements</a>
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question7_2 = true" (closed)="question7_2 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  À quel moment suis-je prélevé(e) de ma réservation ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Le prélèvement se fait le lendemain de votre réservation sur votre
              carte bancaire (préalablement enregistrée). Vous recevrez
              également un mail récapitulatif correspondant à ce prélèvement.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question7_3 = true" (closed)="question7_3 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  À quoi correspond le dépôt de garantie lorsque je loue un
                  véhicule ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Lorsque vous louez un véhicule, un dépôt de garantie est retenu au
              moment de la location sous forme d’empreinte bancaire sur votre
              compte. Il ne s’agit en aucun cas d’un débit sur votre carte
              bancaire mais d’un montant bloqué. <br />
              Ce dépôt de garantie est automatiquement levé, débloquant ainsi la
              somme de votre compte bancaire, 7 jours après la fin de la
              location si aucun incident n’a été déclaré sur le véhicule
              postérieurement à votre réservation. <br />
              Le dépôt de garantie peut être utilisé en cas de dommage sur le
              véhicule pendant la location, ou pour couvrir d'éventuels frais
              annexes (retard, kilomètres supplémentaires, véhicule rendu sale,
              etc.).
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question7_4 = true" (closed)="question7_4 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Ma carte de paiement est bloquée ou expirée, que dois-je faire
                  ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Il faut vous rendre sur votre espace client pour enregistrer votre
              carte bancaire en cours de validité. Pour cela, rendez-vous sur
              votre espace client via le site internet Clem’, dans la rubrique
              <a href="https://clem.mobi/auth/mes-paiements">Mes paiements</a>
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_5 = true" (closed)="question7_5 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Où puis-je consulter mes dernières dépenses en terme
                  d’utilisation ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Ces informations sont disponibles sur votre espace client, dans la
              rubrique
              <a href="https://clem.mobi/auth/mes-paiements">Mes paiements</a>
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_6 = true" (closed)="question7_6 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Quels sont les coûts supplémentaires pour lesquels je peux
                  être facturé(e) ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Consultez les articles 19.10 et 19.11 des
              <a href="https://clem.mobi/cgu">Conditions Générales d’Utilisation</a>
            </p>
          </mat-expansion-panel>

          <!--Sous categorie-->
          <p class="text-center bloc text-light">Les coûts supplémentaires</p>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_7 = true" (closed)="question7_7 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Suis-je facturé(e) en plus pour le rechargement du véhicule
                  que j’ai loué ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              La recharge à la restitution du véhicule loué est incluse dans le
              prix de la réservation. Toute recharge au cours de votre
              réservation est à vos frais.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_8 = true" (closed)="question7_8 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Qui prend en charge les frais en cas de panne de batterie ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              L’usager est responsable de s’assurer qu’il a assez d’autonomie
              pour son utilisation avant son départ ou de se recharger pendant
              l’utilisation en cas de besoin. Clem’ peut donc facturer des frais
              de remorquage/fourrière si nécessaire.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_9 = true" (closed)="question7_9 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Qui prend en charge les frais en cas de panne mécanique ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              En cas de panne mécanique, les frais de remorquages sont pris en
              charge à hauteur de 250 euros. Si vous respectez la procédure
              indiquée par l’assistance technique.
            </p>
          </mat-expansion-panel>

          <!--question-->
          <mat-expansion-panel class="question" (opened)="question7_10 = true" (closed)="question7_10 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  J’ai rendu le véhicule que j’ai loué en retard, ai-je des
                  pénalités ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Tout véhicule rendu en retard vous sera facturé par des pénalités.
              <br />
              Pour éviter cela, vous devez prolonger votre réservation, avant
              que celle-ci soit terminée. Rendez-vous sur votre espace client,
              dans la rubrique :
              <a href="https://clem.mobi/auth/reservations">Mes réservations</a>
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>

      <!--Catégorie 8  Assurance-->
      <mat-accordion class="">
        <mat-expansion-panel class="categorie mt-4" (opened)="categorie8 = true" (closed)="categorie8 = false">
          <!--Header-->
          <mat-expansion-panel-header class="panelcard">
            <mat-panel-title class="row justify-content-center text-light bloc">
              <p class="col-12 text-center">Assurance</p>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question8_1 = true" (closed)="question8_1 = false">
            <mat-expansion-panel-header class="panelheader3">
              <mat-panel-title>
                <p class="childbloc">
                  Quel est le type d’assurance ? Quelles sont mes conditions
                  d’assurance ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Vous êtes assuré(e) tous risques, les dégâts sont assurés si vous
              êtes responsable ou pas. Vous serez néanmoins facturé de la
              franchise si vous êtes responsable ou si le tiers responsable
              n’est pas identifié.<br />
              Pour que les dégâts soient pris en charge par l’assurance et que
              vous soyez limité au montant de la franchise, vous devez respecter
              les conditions de l’assurance : <br />
              - Être titulaire d’un permis de conduire valable<br />
              - Être celui identifié à la réservation <br />
              - Nous fournir un constat amiable dûment rempli à
              <a href="mailto:contact@clem.mobi">contact@clem.mobi</a><br />
              - Ne pas être sous l’emprise d’alcool ou de stupéfiants<br />
              - Respecter le code de la route.<br />

              Si les conditions ne sont pas respectées, vous serez facturé(e) de
              l’intégralité des réparations.
            </p>
          </mat-expansion-panel>

          <!--Questions-->
          <mat-expansion-panel class="question" (opened)="question8_2 = true" (closed)="question8_2 = false">
            <mat-expansion-panel-header class="panelheader2">
              <mat-panel-title>
                <p class="childbloc">
                  Suis-je obligé(e) d’avoir une assurance automobile ?
                </p>
              </mat-panel-title>

              <!--reponse-->
            </mat-expansion-panel-header>
            <p class="textbloc">
              Non, vous n’êtes pas obligé(e) d’avoir une assurance personnelle
              automobile pour utiliser le service d’autopartage.
            </p>
          </mat-expansion-panel>


          <!--Questions-->
<mat-expansion-panel class="question" (opened)="question8_3 = true" (closed)="question8_3 = false">
  <mat-expansion-panel-header class="panelheader2">
    <mat-panel-title>
      <p class="childbloc">
        J'ai eu un accident, que dois-je faire ?
      </p>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- Réponse -->
  <div class="textbloc">
    <p>
      Rendez-vous sur la page d'assistance :
      <a href="https://www.clem-e.com/a5" target="_blank">https://www.clem-e.com/a5</a>
      et suivez la procédure.
    </p>

    <p><strong>1/ Appelez l'assistance technique disponible 24/7.</strong><br>
      Elle va vous communiquer :
    </p>
    <ul>
      <li>Le numéro de contrat d'assurance</li>
      <li>Le nom de l'assuré</li>
      <li>Le numéro de téléphone de l'assistance assurance</li>
    </ul>

    <p><strong>2/ Appelez l'assistance de l'assurance disponible 24/7</strong></p>
    <p>Donnez-leur :</p>
    <ul>
      <li>Le numéro de contrat d'assurance</li>
      <li>Le nom de la flotte (CLEM’) en précisant qu’il s’agit d’une flotte ALLIANZ non désignée</li>
      <li>L’immatriculation</li>
      <li>La mention « contrat flotte/location/location courte durée »</li>
      <li>Le nom du conducteur</li>
      <li>L'adresse de l'événement</li>
      <li>Rappelez qu'il s'agit de véhicules électriques</li>
      <li>L’adresse de la station d'origine</li>
    </ul>

    <p>
      Tous les véhicules sont assurés. Si l'assurance ne trouve pas le contrat,
      <strong>insistez</strong> en répétant que c'est un contrat type
      <strong>« flotte/location/location courte durée »</strong>.
    </p>

    <p><strong>3/ Demandez au remorqueur d'amener le véhicule au garage le plus proche de l'emplacement.</strong></p>

    <p><strong>4/ Attendez le dépanneur jusqu'à la prise en charge du véhicule et remplissez le constat d'accident.</strong></p>

    <p><strong>5/ Envoyez un mail à </strong> <a href="mailto:contact@clem.mobi">contact@clem.mobi</a>
      <strong> avec le lieu de remorquage immédiatement</strong> et avec le constat d'accident sous 5 jours.
    </p>

    <p>Nous restons à votre disposition.</p>
  </div>
</mat-expansion-panel>




        </mat-expansion-panel>
      </mat-accordion>




      <div class="row justify-content-center  mt-5">
        <div class="col-12 ">
          <p class="renseignement text-center bloc mt-2">
            Vous souhaitez être renseigné(e) sur un autre sujet ?
          </p>
          <h2>
            <a href="https://www.clem-e.com/contactusager">Contactez-nous</a>
          </h2>

        </div>
      </div>




    </div>
  </div>

</div>



<div *ngIf="new === true" class="container mt-2">
  <div class="row">
    <div class="col-12 ">
      <h1 class="col-12 primary-font"><b>FAQ</b></h1>






<div class="faq-container">

  <!-- 🔹 LEVEL 1 : PARENT -->
  <mat-accordion multi="true">

    <mat-expansion-panel *ngFor="let parent of faqs" class="parent-panel" 
    [ngClass]="{
        'mam': siteType === 'mam',
        'remi': siteType === 'remi',
        'default': siteType === 'default'
      }">

      <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
          {{ parent.name }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- 🔹 CHILDREN (PAS accordion) -->
      <div *ngFor="let child of parent.children" class="child-block">

        <div class="child-title">
          {{ child.name }}
        </div>

        <!-- 🔹 QUESTIONS -->
        <mat-accordion multi="true">

          <mat-expansion-panel *ngFor="let q of child.questions" class="question-panel">

            <mat-expansion-panel-header class="question-header">
              <mat-panel-title>
                {{ q.question }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="faq-answer" [innerHTML]="q.answer"></div>

          </mat-expansion-panel>

        </mat-accordion>

      </div>

    </mat-expansion-panel>

  </mat-accordion>



     <div class="row justify-content-center  mt-5">
        <div class="col-12 ">
          <p class="renseignement text-center bloc mt-2">
            Vous souhaitez être renseigné(e) sur un autre sujet ?
          </p>
          <h2>
            <a href="https://www.clem-e.com/contactusager">Contactez-nous</a>
          </h2>

        </div>
      </div>

</div>


    </div>

  </div>
  </div>